import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { tippy } from '@tippyjs/react';

import { FaTasks } from 'react-icons/fa';
import { BiHome } from 'react-icons/bi';
import { MdAdminPanelSettings, MdOutlineBusinessCenter, MdOutlinePeopleAlt } from 'react-icons/md';
import { HiDocumentArrowDown } from 'react-icons/hi2';
import { BsBug, BsQuestionCircle } from 'react-icons/bs';
import { VscDebugConsole } from 'react-icons/vsc';

import {
  selectCurrentEntity,
  selectCurrentSurvey,
  selectCurrentVersion,
  selectDirty,
  selectDisplayDebug,
  selectDisplayShareModal,
  selectSelectedCollaborator,
  setDirty,
  setDisplayDebug,
  setModal,
  setSidenavState,
  selectAdminStepsSelectedEntity,
} from '../../reducers/app.reducer';
import {
  selectAccount,
  selectActiveAccount,
  selectImpersonated,
  selectSelectedAccount,
  selectUser,
  setSelectedAccount,
} from '../../reducers/account.reducer';
import { selectAllContentfulData } from '../../reducers/contentful.reducer';

import { MoreOptions } from '../more-option/MoreOption';
import { Modal } from '../modal/Modal';
import { Button } from '../Button';

import { COLORS } from '../../utils/constants';
import { paths } from '@routes/routes.constants';

export interface dirtyModalInterface {
  show: boolean;
  options: {
    actions: Array<any>;
  };
}

export const Menu = () => {
  const history = useHistory();
  const dispatch = useDispatch<any>();
  const homeRef = useRef(null);
  const collabRef = useRef(null);
  const driveRef = useRef(null);
  const docRef = useRef(null);
  const actionsRef = useRef(null);
  const debugModeRef = useRef(null);
  const debugConsoleRef = useRef(null);
  const helpRef = useRef(null);
  const entityRef = useRef(null);
  const contentfulData = useSelector(selectAllContentfulData);
  const currentSurvey = useSelector(selectCurrentSurvey);
  const currentVersion = useSelector(selectCurrentVersion);
  const currentEntity = useSelector(selectCurrentEntity);
  const selectedAdminStepEntity = useSelector(selectAdminStepsSelectedEntity);
  const displayShareModal = useSelector(selectDisplayShareModal);
  const account = useSelector(selectAccount);
  const activeAccount = useSelector(selectActiveAccount);
  const displayDebug = useSelector(selectDisplayDebug);
  const impersonated = useSelector(selectImpersonated);
  const currentUser = useSelector(selectUser);
  const selectedCollaborator = useSelector(selectSelectedCollaborator);
  const selectedAccount = useSelector(selectSelectedAccount);
  const isDirty = useSelector(selectDirty);
  const [dirtyModal, setDirtyModal] = useState({
    show: false,
    actions: [],
  });

  let showActionPlan: boolean;

  if (currentUser.role !== 'guest') {
    showActionPlan = activeAccount?.entities?.some(entity => entity?.actionPlan?.actions?.some(action => action?.active));
  } else if (currentUser?.sharedItems?.actions?.length) {
    showActionPlan = currentUser?.sharedItems?.actions?.some(action =>
      activeAccount?.entities?.some(entity => entity._id === action.entityId && entity?.actionPlan?.actions?.some(action => action?.active))
    );
  } else {
    showActionPlan = false;
  }

  const preventDefault = e => e.preventDefault();

  const getOptions = () => {
    return [
      {
        label: 'Conditions générales d’utilisation',
        onClick: () => window.open('/CGU Dipeeo app.pdf', '_blank'),
      },
      {
        label: 'Politique de confidentialité',
        onClick: () => window.open('/Dipeeo - FR -Politique_de_confidentialite -app_en_ligne.pdf', '_blank'),
      },
    ];
  };

  const print = () => {
    console.log({
      contentfulData,
      currentEntity,
      currentSurvey,
      currentVersion,
      account,
      impersonated,
      displayShareModal,
      activeAccount,
      currentUser,
      selectedCollaborator,
      selectedAccount,
      selectedAdminStepEntity,
    });
  };

  useEffect(() => {
    tippy(homeRef.current, {
      content: 'Tableau de bord',
      arrow: true,
      placement: 'right',
    });
    tippy(driveRef.current, {
      content: 'Vos documents sur Google Drive',
      arrow: true,
      placement: 'right',
    });
    showActionPlan &&
      tippy(actionsRef.current, {
        content: "Plan d'action",
        arrow: true,
        placement: 'right',
      });
    tippy(debugConsoleRef.current, {
      content: 'Print Console',
      arrow: true,
      placement: 'right',
    });
    tippy(debugModeRef.current, {
      content: 'Affichage debug',
      arrow: true,
      placement: 'right',
    });
    tippy(docRef.current, {
      content: 'Documents',
      arrow: true,
      placement: 'right',
    });
    tippy(collabRef.current, {
      content: 'Collaborateurs',
      arrow: true,
      placement: 'right',
    });
    tippy(entityRef.current, {
      content: 'Entités',
      arrow: true,
      placement: 'right',
    });
  }, []);

  const handleMouseLeave = () => {
    dispatch(setSidenavState(null));
  };

  const handleOpenMenu = options => {
    dispatch(setDirty(false));
    dispatch(
      setSidenavState({
        open: true,
        type: options.type,
        level: options.level,
      })
    );
  };

  const handleChangePage = (targetPath, closePanel) => {
    dispatch(setDirty(false));
    dispatch(setModal({ show: false, type: null }));
    if (targetPath) {
      history.push(targetPath);
    }
    if (closePanel) {
      handleMouseLeave();
    }
  };

  const closeDirtyModal = () => {
    setDirtyModal({ show: false, actions: [] });
  };

  const handleMenuClick = (type, options) => {
    if (options.type === 'admin' && account?.accountType === 'agency') {
      dispatch(setSelectedAccount(account));
      history.push(paths.admin);
      return;
    }
    if (isDirty) {
      setDirtyModal({
        show: true,
        actions: [
          {
            buttonType: 'danger',
            label: 'Continuer sans sauvegarder',
            onClick: () => {
              closeDirtyModal();
              if (type === 'page') {
                handleChangePage(options.targetPath, true);
              } else {
                handleOpenMenu({ type: options.type, level: options.level });
              }
            },
          },
          {
            label: 'annuler',
            onClick: closeDirtyModal,
            buttonType: 'secondary',
          },
        ],
      });
    } else {
      if (type === 'page') {
        handleChangePage(options.targetPath, true);
      } else {
        handleOpenMenu({ type: options.type, level: options.level });
      }
    }
  };

  return (
    <>
      <MenuContainer>
        <MenuSection expand={true}>
          <MenuItem
            ref={homeRef}
            /*onMouseEnter={handleMouseLeave}*/
            onClick={() => handleMenuClick('page', { targetPath: paths.dashboardGroup, closePanel: true })}
            selected={history.location.pathname === paths.dashboardGroup}>
            <BiHome />
          </MenuItem>
          <MenuItem
            ref={entityRef}
            onClick={() => handleMenuClick('menu', { type: 'entities', level: '1' })}
            admin={false}
            selected={history.location.pathname === paths.dashboardEntity || history.location.pathname === paths.survey}>
            <MdOutlineBusinessCenter />
          </MenuItem>

          {currentUser.role !== 'guest' && (
            <>
              <MenuItem
                ref={collabRef}
                admin={false}
                onClick={() => handleMenuClick('menu', { type: 'collaborators', level: '1' })}
                selected={history.location.pathname === paths.collaborators}>
                <MdOutlinePeopleAlt />
              </MenuItem>
              <MenuItem
                ref={docRef}
                onClick={() => handleMenuClick('page', { targetPath: paths.documents, closePanel: true })}
                selected={history.location.pathname === paths.documents}>
                <HiDocumentArrowDown />
              </MenuItem>
            </>
          )}
          {showActionPlan && (
            <MenuItem
              ref={actionsRef}
              admin={false}
              /*onMouseEnter={handleMouseLeave}*/
              onClick={() => handleMenuClick('page', { targetPath: paths.userAction, closePanel: true })}
              selected={history.location.pathname.includes(paths.userAction)}>
              <FaTasks />
            </MenuItem>
          )}
        </MenuSection>
        {(account?.accountType === 'superadmin' || account?.accountType === 'agency') && currentUser?.role !== 'guest' && (
          <MenuSection>
            <MenuSectionTitle>Admin</MenuSectionTitle>
            <MenuItem
              onClick={() => handleMenuClick('menu', { type: 'admin', level: '1' })}
              onMouseOver={preventDefault}
              onMouseOut={preventDefault}
              admin={true}
              selected={history.location.pathname === paths.admin}>
              <MdAdminPanelSettings />
            </MenuItem>
            {account?.accountType === 'superadmin' && (
              <>
                <MenuItem
                  ref={debugModeRef}
                  onClick={() => dispatch(setDisplayDebug(!displayDebug))}
                  selected={displayDebug}
                  /*onMouseEnter={handleMouseLeave}*/
                >
                  <BsBug />
                </MenuItem>
                <MenuItem ref={debugConsoleRef} onClick={print} onMouseEnter={handleMouseLeave}>
                  <VscDebugConsole />
                </MenuItem>
              </>
            )}
          </MenuSection>
        )}
        <MenuSection>
          <MenuItem ref={helpRef} onMouseEnter={handleMouseLeave} onMouseOver={preventDefault}>
            <MoreOptions
              icon={BsQuestionCircle}
              options={getOptions()}
              svgColor={'white'}
              removeBorder={true}
              offset={[0, 22]}
              hover={true}></MoreOptions>
          </MenuItem>
        </MenuSection>
      </MenuContainer>
      <Modal show={dirtyModal.show} onClose={closeDirtyModal} title={'Modifications en cours'}>
        <span>Vous avez des modifications non sauvegardées. Voulez-vous continuer ?</span>
        <ModalActions>
          {dirtyModal.actions.map((action, index) => (
            <Button label={action.label} key={index} onClick={action.onClick} type={action.buttonType} />
          ))}
        </ModalActions>
      </Modal>
    </>
  );
};

const ModalActions = styled.div`
  display: flex;
  column-gap: 20px;
  width: 100%;
  justify-content: flex-end;
`;

const MenuSection = styled.div<{ expand?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  row-gap: 20px;
  align-items: center;
  justify-content: flex-start;
  ${({ expand }) => expand && 'flex: 1;'}
`;

const MenuSectionTitle = styled.div`
  font-family: 'Nunito', sans-serif;
  color: white;
`;

const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  row-gap: 10px;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding-bottom: 50px;
`;

const MenuItem = styled.div<{ selected?: boolean; admin?: boolean }>`
  color: white;
  font-size: 1.3rem;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  position: relative;
  cursor: pointer;
  border-radius: 15px;
  background-color: transparent;
  width: 45px;
  height: 45px;
  align-items: center;
  justify-content: center;
  border: 2px solid transparent;

  &:hover {
    border: 2px solid #c8e3f6;
  }

  ${({ selected }) =>
    selected &&
    `
    color: ${COLORS.Black};
    background-color: #C8E3F6;
  `}
  span {
    margin-top: 3px;
  }

  svg {
    width: 24px;
    height: 24px;
    min-width: fit-content;
  }
`;
